import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { format, parseISO } from "date-fns";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export function DatePicker({ value, onChange, testId, placeholder = "Pick a day" }) {
  const [open, setOpen] = useState(false);
  const date = value ? parseISO(value) : undefined;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} aria-label={date ? `Preferred day ${format(date, "d MMMM yyyy")}` : placeholder}
          className="w-full min-h-[44px] rounded-2xl border-2 border-[#e1e2e5] px-4 py-2.5 font-medium text-left flex items-center justify-between gap-2 focus:border-[#004040] outline-none bg-white">
          <span className={date ? "" : "text-[#6b6f76]"}>{date ? format(date, "EEE, d MMM yyyy") : placeholder}</span>
          <CalendarDays size={18} className="text-[#6b6f76] shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-2xl" align="start">
        <Calendar mode="single" selected={date} disabled={{ before: today }} initialFocus
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }} />
      </PopoverContent>
    </Popover>
  );
}
